var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
export function noop() { }
/**
 * 函数节流
 * @param fn 要执行的函数
 * @param threshold 执行间隔，单位毫秒（ms）
 * @param scope 调用函数上下文
 * @returns {Function}
 */
export default function throttle(fn, threshold, scope) {
    if (scope === void 0) { scope = null; }
    var last;
    var deferTimer;
    function throttled() {
        var arg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arg[_i] = arguments[_i];
        }
        // @ts-ignore
        var context = scope || this;
        var now = +new Date();
        var args = arg;
        if (last && now < last + threshold) {
            // hold on to it
            clearTimeout(deferTimer);
            deferTimer = setTimeout(function () {
                last = now;
                fn.apply(context, args);
            }, threshold);
        }
        else {
            last = now;
            fn.apply(context, args);
        }
    }
    return throttled;
}
export var debounce = function (func, delay) {
    var timeout = null;
    var debounced = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (timeout !== null)
            clearTimeout(timeout);
        timeout = setTimeout(function () { return func.apply(void 0, __spread(args)); }, delay);
    };
    return debounced;
};
